import { QUICK_ACTIONS } from "./quickActions";

/** Outline pills that pre-fill the composer (or, signed out, prompt sign-in). */
export default function QuickActionPills({ onPick, className = "" }) {
    return (
        <div className={`flex flex-wrap items-center gap-2 ${className}`}>
            {QUICK_ACTIONS.map(({ id, label, icon: Icon, prompt }) => (
                <button
                    key={id}
                    type="button"
                    onClick={() => onPick(prompt)}
                    className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-white px-3.5 py-1.5 font-Mulish text-sm text-primary-700 transition-colors hover:bg-primary-50"
                >
                    <Icon size={14} />
                    {label}
                </button>
            ))}
        </div>
    );
}
